<template>
  <div class="mx-auto px-4 pb-12 sm:px-4 lg:px-8">
    <div class="rounded-lg">
      <div class="flex flex-col space-y-4">
        <base-button
          :disabled="getLoadingRunClosePeriod"
          v-on:click="handleClosePeriod"
        >
          <svg
            v-if="getLoadingRunClosePeriod"
            aria-hidden="true"
            class="text-white-200 fill-blue-600 inline h-4 w-4 animate-spin"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          Jalankan Tutup Buku
        </base-button>
        <div>
          <Tabs
            :tabs-data="tabs"
            :tab-active="tabActive"
            @updateTabActive="changeTab"
          >
            <template v-slot:default="{ tabActive }">
              <template
                v-if="tabActive === 'Periode Tutup Buku'"
                class="transition duration-300 ease-in-out"
              >
                <div>
                  <div class="flex w-full justify-end">
                    <base-input
                      type="number"
                      @input="handleChangeYear"
                      v-model="filter.year"
                      label="Pilih Tahun"
                      with-label
                      :min="`${dayjs().year()}`"
                    />
                  </div>
                  <div class="my-4">
                    <Datatable
                      :paginated="false"
                      :footer="false"
                      @pagechanged="onPageChangePeriods"
                    >
                      <template v-slot:thead>
                        <thead class="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              class="cursor-pointer px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                            >
                              Dimulai Pada
                            </th>
                            <th
                              scope="col"
                              class="cursor-pointer px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                            >
                              Bulan
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:tbody>
                        <tbody v-if="getPeriods.data.length">
                          <tr
                            class="cursor-pointer bg-white hover:bg-green-100"
                            v-for="(data, dataIdx) in getPeriods.data"
                            :key="data.id"
                            :class="[
                              isRowDisabled(data)
                                ? 'cursor-not-allowed opacity-50'
                                : '',
                              dataIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                              isCurrentPeriod(data)
                                ? 'bg-green-300 font-bold'
                                : '',
                            ]"
                            :style="
                              isCurrentPeriod(data)
                                ? 'background-color: rgb(187 247 208);'
                                : null
                            "
                            @click="
                              isRowDisabled(data)
                                ? null
                                : handlePeriodModal(data)
                            "
                          >
                            <td
                              class="whitespace-nowrap px-6 py-4 text-sm text-gray-700"
                            >
                              {{
                                dayjs(data.attributes.start_date).format('LLLL')
                              }}
                            </td>
                            <td
                              class="whitespace-nowrap px-6 py-4 text-sm font-bold text-gray-700"
                            >
                              {{ data.attributes.name }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr class="bg-white">
                            <td
                              class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900"
                              colspan="2"
                            >
                              Data tidak ditemukan
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </Datatable>
                  </div>
                </div>
              </template>
            </template>
          </Tabs>
        </div>
      </div>
    </div>
    <Modal
      :showing="openPeriodModal"
      @close="handlePeriodModal"
      :showClose="openPeriodModal"
      :backgroundClose="true"
      size="max-w-lg"
    >
      <form v-on:submit.prevent="handleSubmitForm">
        <base-input
          label="Periode Tutup Buku"
          type="datetime-local"
          class="my-4"
          inset
          with-label
          v-model="form.selectedPeriod.attributes.start_date"
        />
        <div class="flex justify-end">
          <base-button
            type="submit"
            :disabled="!form.selectedPeriod.attributes.start_date"
            >Ubah Periode</base-button
          >
        </div>
      </form>
    </Modal>
    <loading v-if="getLoading"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { StorageService } from '@/services/storage.service';
import Datatable from '@/components/base/Datatable';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import Modal from '@/components/base/BaseModal';
import dayjs from 'dayjs';
import debounce from 'debounce';
import Tabs from '@/components/Tabs.vue';

export default {
  name: 'Setup',
  components: {
    Datatable,
    Modal,
    BaseInput,
    BaseButton,
    Tabs,
  },
  data() {
    return {
      tabs: ['Periode Tutup Buku'],
      tabActive: 'Periode Tutup Buku',
      openPeriodModal: false,
      filter: {
        year: dayjs().year(),
      },
      form: {
        selectedPeriod: {
          id: '',
          attributes: {
            start_date: '',
          },
        },
      },
      months: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ],
    };
  },
  computed: {
    ...mapGetters({
      getPeriods: 'periods/getPeriods',
      getLoading: 'periods/getLoading',
      getLoadingRunClosePeriod: 'setups/getLoadingRunClosePeriod',
    }),
    periodParams() {
      return {
        'filter[year]': this.filter.year,
      };
    },
  },
  methods: {
    ...mapActions({
      fetchPeriods: 'periods/fetchPeriods',
      updatePeriod: 'periods/updatePeriod',
      runClosePeriod: 'setups/runClosePeriod',
    }),
    dayjs,
    changeTab(tab) {
      this.currentTab = tab;
    },
    isRowDisabled(period) {
      return this.months.indexOf(period.attributes.name) < dayjs().month();
    },
    isCurrentPeriod(period) {
      return this.months.indexOf(period.attributes.name) == dayjs().month();
    },
    handleSubmitForm() {
      const payload = {
        data: {
          type: 'periods',
          id: this.form.selectedPeriod.id,
          attributes: {
            start_date: dayjs(
              this.form.selectedPeriod.attributes.start_date
            ).toISOString(),
          },
        },
      };
      this.updatePeriod(payload).then((res) => {
        if (res) {
          this.openPeriodModal = false;
          this.fetchPeriods({ ...this.periodParams });
        }
      });
    },
    handleChangeYear: debounce(function () {
      this.fetchPeriods({ ...this.periodParams });
    }, 500),
    handlePeriodModal(periods) {
      if (periods) {
        periods.attributes.start_date = dayjs(
          periods.attributes.start_date
        ).format('YYYY-MM-DDTHH:mm');
        this.form.selectedPeriod = JSON.parse(JSON.stringify(periods));
      }
      this.openPeriodModal = !this.openPeriodModal;
    },
    onPageChangePeriods() {},
    handleClosePeriod: function () {
      this.runClosePeriod();
    },
  },
  async created() {
    this.fetchPeriods({ ...this.periodParams });
  },
};
</script>
